import { Typography } from '@mui/material';
import { ButtonContainer, StyledButton } from '../UserAccountPanel.styles';
import { useDispatch } from 'react-redux';
import { logout } from '../../../../redux/actions/userActions';
import { useNavigate } from 'react-router-dom';

// This file will contain a 'Delete Account' button once we have the functionality for it

const ActionButtons = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    // Call the logout action to clear the user session and local storage
    dispatch(logout());
    navigate('/login');
  };

  return (
    <ButtonContainer>
      <StyledButton onClick={handleSignOut}>
        <Typography variant="bodyRegular">Sign out</Typography>
      </StyledButton>
    </ButtonContainer>
  );
};

export default ActionButtons;
